import { Component, Input, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'checkbox-formly',
  templateUrl: './checkbox-formly.component.html',
  styleUrls: ['./checkbox-formly.component.scss']
})
export class CheckboxFormlyComponent extends FieldType {}
